import { render, staticRenderFns } from "./SplashScreen.vue?vue&type=template&id=0d0cac6d&"
var script = {}
import style0 from "./SplashScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SplashScreen.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/SplashScreen.vue
// module id = 2302
// module chunks = 1